import { WarrntyItemAction } from "./types";

export const fetchOptions = () =>
  ({
    type: WarrntyItemAction.FETCH_OPTIONS,
  }) as const;

export const setOptions = (payload) =>
  ({
    type: WarrntyItemAction.SET_OPTIONS,
    payload,
  }) as const;

export const cleanUpState = () =>
  ({
    type: WarrntyItemAction.CLEAN_UP,
  }) as const;

export const addWarrntyItem = (payload) =>
  ({
    type: WarrntyItemAction.ADD,
    payload,
  }) as const;

export const setWarrntyClaimId = (payload) =>
  ({
    type: WarrntyItemAction.SET_WARRNTYID_CLAIMID,
    payload,
  }) as const;

export const setInvoiceURL = (payload) =>
  ({
    type: WarrntyItemAction.SET_INVOICE_URL,
    payload,
  }) as const;

export const showSuccesModal = () =>
  ({
    type: WarrntyItemAction.SHOW_SUCCES_MODAL,
  }) as const;

export const hideSuccesModal = () =>
  ({
    type: WarrntyItemAction.HIDE_SUCCES_MODAL,
  }) as const;
